<form [formGroup]="form" (ngSubmit)="onSubmit()" class="mt-4 mb-4 w-100 text-light p-5 border">

    <div class="d-flex flex-column flex-sm-row justify-content-between">

        <div class="mb-3 col-12 col-sm-5 p-0">
            <input type="text" class="form-control" formControlName="name" placeholder="Nombre y apellidos *"
                [class.is-invalid]="form.controls.name.touched && form.controls.name.invalid" />
        </div>


        <div class="mb-3 col-12 col-sm-6 p-0">
            <input type="email" class="form-control" formControlName="email" placeholder="Email *"
                [class.is-invalid]="form.controls.email.touched && form.controls.email.invalid" />
        </div>
    </div>

    <div class="flex-row text-left">


        <div class="mb-3 col-12 p-0">
            <label class="form-label">¿Prefieres llamada o WhatsApp? (teléfono) *</label>
            <div class="flex-row">
                <select class="form-select col-3" formControlName="prefix">
                    <option *ngFor="let p of prefixes()" [value]="p.prefix">
                        {{ p.country }} ({{ p.prefix }})
                    </option>
                </select>
                <input type="text" class="form-control ml-3" formControlName="phone"
                    [class.is-invalid]="form.controls.phone.touched && form.controls.phone.invalid" />
            </div>
        </div>
    </div>

    <div class="d-flex flex-column flex-sm-row justify-content-between text-left mt-3">

        <div class="mb-3 col-12 col-sm-5 p-0">
            <label class="form-label d-lg-none">¿Cuántos años de experiencia tienes? *</label>
            <input type="text" class="form-control" formControlName="experience"
                placeholder="¿Cuántos años de experiencia tienes? *"
                [class.is-invalid]="form.controls.experience?.touched && form.controls.experience?.invalid" />
        </div>


        <div class="mb-3 col-12 col-sm-6 p-0">
            <label class="form-label d-lg-none">Copia y pega el enlace de tu perfil a LinkedIn *</label>
            <input type="text" class="form-control" formControlName="linkedin"
                placeholder="Copia y pega el enlace de tu perfil a LinkedIn *"
                [class.is-invalid]="form.controls.linkedin?.touched && form.controls.linkedin?.invalid" />
        </div>
    </div>


    <div class="mb-3 text-left">
        <label class="form-label">¿En qué área encajaría tu perfil profesional? *</label>

        <select class="form-select" formControlName="sector">
            <option value="">Selecciona una opción</option>

            <option *ngFor="let sector of sectors" [value]="sector">{{ sector }}</option>
        </select>


        <input *ngIf="form.value.sector === 'Otro'" type="text" class="form-control mt-2"
            placeholder="Especifica tu sector" formControlName="otherSector" />

        <div class="text-danger" *ngIf="form.controls.sector.touched && form.controls.sector.invalid">
            El sector es obligatorio.
        </div>
    </div>

    <div class="d-flex flex-column flex-sm-row col-12">

        <div class="mb-3 text-left col-12 col-sm-6">
            <label class="form-label">Selecciona tus tecnologías o stack profesional *</label>

            <div *ngFor="let technicalSector of technicalSectors" class="form-check mb-1">
                <input type="checkbox" class="form-check-input" [value]="technicalSector"
                    (change)="toggleTechnicalSector($event, technicalSector)"
                    id="technicalSector-{{ technicalSector }}" />
                <label class="form-check-label" for="technicalSector-{{ technicalSector }}">
                    {{ technicalSector }}
                </label>
            </div>


            <input *ngIf="selectedTechnicalSectors().includes('Otro')" type="text" class="form-control mt-2"
                placeholder="Especifica tu sector" formControlName="otherTechnicalSector" />

            <div class="text-danger" *ngIf="sectorTouched() && selectedTechnicalSectors().length === 0">
                Debes elegir al menos una tecnología.
            </div>

        </div>


        <div class="mb-3 text-left col-12 col-sm-6">
            <label class="form-label">Selecciona los tipos de contrato que te interesan (máx. 3) *</label>

            <div *ngFor="let contract of contracts" class="form-check mb-1">
                <input type="checkbox" class="form-check-input" [value]="contract"
                    (change)="toggleContract($event, contract)" [disabled]="
                !selectedContracts().includes(contract) &&
                selectedContracts().length >= 3
            " id="contract-{{ contract }}" />

                <label class="form-check-label" for="contract-{{ contract }}">
                    {{ contract }}
                </label>
            </div>

            <div class="text-danger" *ngIf="touchedContracts() && selectedContracts().length === 0">
                Debes elegir al menos un contrato.
            </div>

            <div class="text-warning mt-1" *ngIf="selectedContracts().length === 3">
                Has alcanzado el máximo de 3 tipos de contrato.
            </div>
        </div>
    </div>






    <div class="form-check mb-3">
        <label class="form-check-label">
            <input type="checkbox" class="form-check-input" formControlName="warning" />
            Acepto los <a href="/aviso-legal/privacidad" target="_blank">términos y condiciones</a> *
        </label>

        <div class="text-danger" *ngIf="form.controls.warning.touched && form.controls.warning.invalid">
            Debes aceptar los términos.
        </div>
    </div>

    <p *ngIf="success()" class="success-text">
        ¡Formulario enviado con éxito!
    </p>

    <p *ngIf="error()" class="error-text">
        Ha ocurrido un error al enviar el formulario. Inténtalo de nuevo.
    </p>


    <button class="btn btn-light" type="submit" [disabled]="loading() || !formReady()">
        {{ loading() ? "Enviando..." : "Enviar" }}
    </button>

</form>